import css from 'styled-jsx/css';

const styles = css.global`#renegociacao25-vantagens {
  padding: 40px 0;
  background: #C00;
  overflow: hidden;
  position: relative;
}

#renegociacao25-vantagens .ctn-home-24 {
  position: relative;
  z-index: 2;
}

#renegociacao25-vantagens .santander-symbol {
  position: absolute;
  bottom: -71px;
  right: -179px;
  width: 593px;
  opacity: 0.15;
  mix-blend-mode: multiply;
}

#renegociacao25-vantagens .vantagens-titulo.desktop {
  display: none;
}

#renegociacao25-vantagens .vantagens-titulo {
  color: #FFF;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  max-width: 216px;
  width: 100%;
  margin-bottom: 24px;
}

#renegociacao25-vantagens .vantagens-carrossel .slide {
  display: flex;
  width: 224px;
  height: auto;
  padding: 24px 16px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  border-radius: 4px;
  border: 1px solid #FFF;
  margin-right: 16px;
  flex: 0 0 224px;
}

#renegociacao25-vantagens .vantagens-carrossel .slide .slide-textos {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

#renegociacao25-vantagens .vantagens-carrossel .slide .slide-titulo {
  color: #FFF;
  font-family: "SantanderHeadline";
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

#renegociacao25-vantagens .vantagens-carrossel .slide .slide-texto {
  color: #FFF;
  text-align: center;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
} 

#renegociacao25-vantagens .vantagens-carrossel .home-pagination {
  margin-top: 24px;
}

#renegociacao25-vantagens .home-pagination .embla__prev {
  background-image: url(assets/renegociacao25/vantagens/arrow_l.svg);
}

#renegociacao25-vantagens .home-pagination .embla__next {
  background-image: url(assets/renegociacao25/vantagens/arrow_r.svg);
}

#renegociacao25-vantagens .home-pagination .embla__prev, 
#renegociacao25-vantagens .home-pagination .embla__next {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

#renegociacao25-vantagens .home-pagination .pagination-container .bullet.active, 
#renegociacao25-vantagens .home-pagination .pagination-container .bullet[selected] {
  background-color: #fff;
}

#renegociacao25-vantagens .btn-vantagens-renegociar {
  width: 100%;
  max-width: 220px;
  height: 49px;
  margin: 26px auto 0;
}

@media (min-width: 992px) {
  #renegociacao25-vantagens {
    padding: 80px 0;
  }

  #renegociacao25-vantagens .santander-symbol {
    left: 50%;
    transform: translate(-50%, 0);
    width: 1083px;
    bottom: -263px;
  }

  #renegociacao25-vantagens .vantagens-titulo.mobile {
    display: none;
  }

  #renegociacao25-vantagens .vantagens-titulo.desktop {
    display: flex;
    font-size: 40px;
    line-height: 60px;
    max-width: 100%;
    justify-content: center;
    margin-bottom: 40px;
  }

  #renegociacao25-vantagens .custom-carousel .embla__container {
    margin: auto;
    max-width: 1080px;
  }

  #renegociacao25-vantagens .vantagens-carrossel .slide {
    width: 240px;
    padding: 24px 20px;
    margin-right: 40px;
    flex: 0 0 240px;
  }

  #renegociacao25-vantagens .vantagens-carrossel .slide .slide-titulo {
    font-size: 24px;
  }

  #renegociacao25-vantagens .vantagens-carrossel .home-pagination {
    display: none;
  }

  #renegociacao25-vantagens .btn-vantagens-renegociar {
    max-width: 250px;
    margin:40px auto 0;
  }
}
`;

export default styles;